import { Flex } from "@twilio-paste/core/flex";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { Spinner } from "@twilio-paste/core/spinner";
import { useSelector } from "react-redux";

import { AppState } from "../store/definitions";

export const LoadingPhase = () => {
    // Personalização opcional do "carregando" via brand-config (runtime). Ausente = spinner de hoje.
    const loading = useSelector((state: AppState) => state.config?.prechat?.loading);
    const spinnerColor = loading?.spinnerColor;
    const message = loading?.message;

    return (
        <Flex hAlignContent="center" vAlignContent="center" height="100%" vertical>
            {spinnerColor ? (
                // Spinner herda a cor via currentColor (default color do Paste Spinner = "currentColor").
                <Box data-test="loading-spinner-wrapper" style={{ color: spinnerColor }}>
                    <Spinner title="Autorizando" decorative={false} size="sizeIcon100" />
                </Box>
            ) : (
                <Spinner title="Autorizando" decorative={false} size="sizeIcon100" color="colorTextLink" />
            )}
            {message ? (
                <Text as="p" data-test="loading-message" marginTop="space40" color="colorText">
                    {message}
                </Text>
            ) : null}
        </Flex>
    );
};
